import React from 'react';
import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';
import { AspectRatioBox, AspectRatioBoxProps } from '@moda/om';
import { Image } from '../Image';
import { useDuration, Crossfader } from '../Crossfader';
import './ImageGallery.scss';

export const DEFAULT_ALT_TEXT = 'thumbnail';
export const IMAGE_DURATION_MS = 2000;

type ImageSlide = {
  src: string;
  title?: string | null;
};

type Props = AspectRatioBoxProps & {
  images: ImageSlide[];
  active?: boolean;
};

export const ImageGallery: React.FC<Props> = ({ images, active, className, ...rest }) => {
  const [ref, inView] = useInView({ triggerOnce: true });
  const { cursor } = useDuration({ duration: IMAGE_DURATION_MS, active });

  const [primaryImage, ...secondaryImages] = images;

  return (
    <AspectRatioBox
      className={classNames('ImageGallery', className, {
        'ImageGallery--active': active && secondaryImages.length > 0
      })}
      {...rest}
    >
      {inView && secondaryImages.length > 0 && (
        <Crossfader className="ImageGallery__incoming" cursor={cursor}>
          {images.map(image => (
            <Image
              key={image.src}
              className="ImageGallery__incoming"
              src={image.src}
              alt={image.title || DEFAULT_ALT_TEXT}
            />
          ))}
        </Crossfader>
      )}

      {primaryImage && (
        <Image
          ref={ref}
          className="ImageGallery__image"
          src={inView ? primaryImage.src : ''}
          alt={primaryImage.title || DEFAULT_ALT_TEXT}
        />
      )}
    </AspectRatioBox>
  );
};
